import { APLSearchPage } from 'app/entrypoints/APLSearchPage'
import { APLWelcomePage } from 'app/entrypoints/APLWelcomePage'
import { RegistrationLoginPage } from 'app/entrypoints/RegistrationLoginPage'
import { AmsEligibilityPartnersSearch } from 'legacy/hpscoutso/components/pages/amsEligibilityPartnersSearch/AmsEligibilityPartnersSearch'
import { APLDocumentsHistory } from 'legacy/hpscoutso/components/pages/aplDocumentsHistory/APLDocumentsHistory'
import { AmsLATAMPartnersSearch } from 'legacy/hpscoutso/components/pages/aplLatam/AmsLATAMPartnersSearch'
import { DistributorsOnBehalfLoginPage } from 'legacy/hpscoutso/components/widgets/public/distributorsOnBehalf/DistributorsOnBehalfLoginPage'
import { OnbPageURLs } from 'legacy/lut/classes/models/onboarding/Onboarding'
import React from 'react'

import { LayoutLogin } from 'core/layout/Login'
import { IRouteData } from 'core/routes/types'
import { APLLoginPage } from 'onboarding/components/page/apl'
import { BPTCReconfirmationPage } from 'onboarding/components/page/bpTCReconfirmation/Page'
import { ExecuteTransitionByTokenPage } from 'onboarding/components/page/executeTransitionByTokenPage/ExecuteTransitionByTokenPage'
import { PartnerCompliancePage } from 'onboarding/components/page/partnerCompliancePage/PartnerCompliancePage'

export const CustomRoutes: IRouteData[] = [
  {
    path: '/page/execute-transition-by-token/:token',
    element: <ExecuteTransitionByTokenPage />,
    access: 'Common',
  },
  {
    path: '/page/partner-compliance/status/:status/token/:token',
    element: <PartnerCompliancePage />,
    access: 'Common',
  },
  {
    path: '/page/bp-registration/',
    element: <RegistrationLoginPage />,
    access: 'Guest',
  },
  {
    path: '/page/bp-registration/*',
    element: <RegistrationLoginPage />,
    access: 'Guest',
  },
  {
    path: '/page/simple-partner-registration/',
    element: <APLLoginPage />,
    access: 'Guest',
  },
  {
    path: '/page/simple-partner-registration/*',
    element: <APLLoginPage />,
    access: 'Guest',
  },
  {
    path: '/page/bp-reconfirmation/',
    element: <RegistrationLoginPage />,
    access: 'Guest',
  },
  {
    path: '/page/bp-reconfirmation/*',
    element: <RegistrationLoginPage />,
    access: 'Guest',
  },
  {
    path: '/page/terms-and-conditions/',
    element: <RegistrationLoginPage />,
    access: 'Guest',
  },
  {
    path: '/page/terms-and-conditions/*',
    element: <RegistrationLoginPage />,
    access: 'Guest',
  },
  {
    path: `/page/${OnbPageURLs.DistributorOnBehalfUpdate}/*`,
    element: <DistributorsOnBehalfLoginPage />,
    access: 'Guest',
  },
  {
    path: `/page/${OnbPageURLs.DistributorOnBehalfUpdate}/`,
    element: <DistributorsOnBehalfLoginPage />,
    access: 'Guest',
  },
  {
    path: '/',
    element: <LayoutLogin />,
    access: 'Guest',
  },
  {
    path: '/simple_partner',
    element: <APLWelcomePage />,
    access: 'Common',
  },
  {
    path: '/apl_documents_history',
    element: <APLDocumentsHistory />,
    access: 'Common',
  },
  {
    path: '/simple_partner_search',
    element: <APLSearchPage />,
    access: 'Authorized',
  },
  {
    path: '/ams_eligibility_partner_search',
    element: <AmsEligibilityPartnersSearch />,
    access: 'Authorized',
  },
  {
    path: '/page/ams_latam_partner_search',
    element: <AmsLATAMPartnersSearch />,
    access: 'Authorized',
  },
  {
    path: '/page/partner_dashboard/search/:query/:tab/:time',
    access: 'Authorized',
    wrappedInLayout: true,
  },
  {
    path: '/page/partner_dashboard',
    access: 'Authorized',
    wrappedInLayout: true,
  },
  {
    path: '/page/partner_dashboard/:partnerId',
    access: 'Authorized',
    wrappedInLayout: true,
  },
  {
    path: '/locale/:locale/page/partner_dashboard',
    access: 'Authorized',
    wrappedInLayout: true,
  },
  {
    path: '/locale/:locale/page/partner_dashboard/:partnerId',
    access: 'Authorized',
    wrappedInLayout: true,
  },
  {
    path: '/locale/:locale',
    access: 'Authorized',
    wrappedInLayout: true,
  },
  {
    path: '/locale/:locale/page/:pageId',
    access: 'Authorized',
    wrappedInLayout: true,
  },
  {
    path: '/locale/:locale/page/:pageId/*',
    access: 'Authorized',
    wrappedInLayout: true,
  },
  {
    path: '/page/bp-tc-reconfirmation',
    element: <BPTCReconfirmationPage />,
    access: 'Authorized',
  },
]
